import React, { useRef, useState } from "react";

const PortfolioSection = () => {
  // Dynamic portfolio data
  const portfolioData = [
    // Business Website
    {
      category: "Business Website",
      projects: [
        {
          image: require("../assets/portfolioimg/nidandiagnostics.webp"),
          title: " Nidan Diagnostics",
          url: "https://www.nidandiagnostics.in/",
          // description: "Corporate website designed for brand presence.",
        },
        {
          image: require("../assets/portfolioimg/uniqueac.webp"),
          title: " Unique Ac Projects",
          url: "https://moccasin-quail-304214.hostingersite.com/",
        },
        {
          image: require("../assets/portfolioimg/contiproindustries.webp"),
          title: "Contipro Industries",
          url: "https://palevioletred-shark-806430.hostingersite.com",
        },
        {
          image: require("../assets/portfolioimg/enhancsafe.webp"),
          title: "Enhance Safe",
          url: "https://darkseagreen-barracuda-887051.hostingersite.com",
        },
        {
          image: require("../assets/portfolioimg/trello.webp"),
          title: "Trello Technology",
          url: "https://trellotechnology.com",
        },
        {
          image: require("../assets/portfolioimg/hemocean.webp"),
          title: "Hemocean Outsourcing",
          url: "https://hemocean.com/",
        },
        {
          image: require("../assets/portfolioimg/peoplenorth.webp"),
          title: "People North Website",
          url: "https://peoplenorth.com/",
        },
        {
          image: require("../assets/portfolioimg/thepencilpalette.webp"),
          title: "The Pencil Palette",
          url: "http://thepencilpalette.com/",
        },
        {
          image: require("../assets/portfolioimg/trunkinlove.webp"),
          title: "Trunnk In Love",
          url: "https://www.trunnkinlove.com/",
        },
        {
          image: require("../assets/portfolioimg/agradecables.webp"),
          title: "Agrade Cables",
          url: "https://agradecables.com/",
        },
        {
          image: require("../assets/portfolioimg/ramdas.webp"),
          title: "Ramdas Industries",
          url: "https://ramdas.co.in/",
        },
        {
          image: require("../assets/portfolioimg/shieldit.webp"),
          title: "Shield IT Website",
          url: "https://shieldit.co.in/",
        },
        {
          image: require("../assets/portfolioimg/musclesmentor.webp"),
          title: "Muscles Mentor",
          url: "https://musclesmentor.com/",
        },
      ],
    },

    // e-commerce
    {
      category: "E-commerce Website",
      projects: [
        {
          image: require("../assets/portfolioimg/kawarsa.webp"),
          title: " Kawarsa Ethnic Wear ",
          url: "https://kawarsa.com/",
          // description: "Corporate website designed for brand presence.",
        },
      ],
    },

    // Real Estate
    {
      category: "Real Estate Website",
      projects: [
        {
          image: require("../assets/portfolioimg/checkedrealty.webp"),
          title: " Checked Realty ",
          url: "https://checkedrealty.com/",
        },
        {
          image: require("../assets/portfolioimg/mahindra-crown-kharadi.webp"),
          title: " Mahindra Crown ",
          url: "https://mahindra-crown-kharadi.in/",
        },
        {
          image: require("../assets/portfolioimg/efc.webp"),
          title: "EFC India Website",
          url: "https://efcindia.org/",
        },
      ],
    },

    // Interior Designing
    {
      category: " Interior Designing ",
      projects: [
        {
          image: require("../assets/portfolioimg/aayaamdesignstudio.webp"),
          title: " Aayaam Design",
          url: "https://aayaamdesignstudio.com/",
        },
        {
          image: require("../assets/portfolioimg/kams.webp"),
          title: " Kams Designer",
          url: "https://www.kamsdesigner.com/",
        },
        {
          image: require("../assets/portfolioimg/fabshades.webp"),
          title: "Fab Shades Website",
          url: "https://fabshades.com/",
        },
        {
          image: require("../assets/portfolioimg/life2home.webp"),
          title: "Life 2 Home Website",
          url: "https://life2home.in/",
        },
        {
          image: require("../assets/portfolioimg/unimacinterior.webp"),
          title: "Unimac Interior",
          url: "https://unimacinterior.com/",
        },
      ],
    },

    // Digital Marketing
    {
      category: "Digital Marketing Website",
      projects: [
        {
          image: require("../assets/portfolioimg/a2digisolution.webp"),
          title: "A2 Digi Solution",
          url: "https://a2digisolution.com/",
        },
        {
          image: require("../assets/portfolioimg/teonox.webp"),
          title: "Teonox Website",
          url: "https://teonox.com/",
        },
        {
          image: require("../assets/portfolioimg/awrange.webp"),
          title: "Awrange Website",
          url: "https://awrange.com/",
        },
        {
          image: require("../assets/portfolioimg/socialstardomco.webp"),
          title: "Social Stardom",
          url: "https://socialstardom.co/",
        },
        {
          image: require("../assets/portfolioimg/socialstardomin.webp"),
          title: "Social Stardom",
          url: "https://socialstardom.in/",
        },
        {
          image: require("../assets/portfolioimg/TMK.webp"),
          title: "The Marketing King",
          url: "https://themarketingking.org/",
        },
      ],
    },

    // News
    {
      category: "News Website",
      projects: [
        {
          image: require("../assets/portfolioimg/fmplaynews.webp"),
          title: "FM Play News",
          url: "https://fmplaynews.com/",
        },
        {
          image: require("../assets/portfolioimg/tajnews.webp"),
          title: "Taj777 News Website",
          url: "https://taj777news.com/",
        },
        {
          image: require("../assets/portfolioimg/armani news.webp"),
          title: "Armani Exch247 News",
          url: "https://armaniexch247news.com/",
        },
        {
          image: require("../assets/portfolioimg/tbn.webp"),
          title: "Top Betting News",
          url: "https://top-betting-news.in/",
        },
      ],
    },

    // Education
    {
      category: "Educational Website",
      projects: [
        {
          image: require("../assets/portfolioimg/finest.webp"),
          title: "Finest Concept Academy",
          url: "https://finestconceptacademy.com/",
        },
      ],
    },

    // I-gaming Website
    {
      category: "I-Gaming Website",
      projects: [
        {
          image: require("../assets/portfolioimg/armanicasino.webp"),
          title: "Armani Casino",
          url: "https://armanicasino.com/",
        },
        {
          image: require("../assets/portfolioimg/fmplaycasino.webp"),
          title: "FM Play Casino",
          url: "https://fmplaycasino.com/",
        },
        {
          image: require("../assets/portfolioimg/playon99.webp"),
          title: "Playon99 Website",
          url: "https://playon99.in/",
        },
        {
          image: require("../assets/portfolioimg/taj777.webp"),
          title: "Taj777 Book Website",
          url: "https://taj777book.com/",
        },
        {
          image: require("../assets/portfolioimg/wolf777.webp"),
          title: "Wolf777 Cricket",
          url: "https://wolf777cricket.com/",
        },
        {
          image: require("../assets/portfolioimg/awl.webp"),
          title: "All White Label",
          url: "https://allwhitelabel.com/",
        },
      ],
    },

    // Stocks Website
    {
      category: "Stocks Website",
      projects: [
        {
          image: require("../assets/portfolioimg/stock pro max.webp"),
          title: "Stock Pro Max",
          url: "https://stockpromax.com/",
        },
        {
          image: require("../assets/portfolioimg/capita bazaar.webp"),
          title: "Capita Bazaar",
          url: "https://capitabazaar.in/",
        },
        {
          image: require("../assets/portfolioimg/armani pay.webp"),
          title: "Armani Pay",
          url: "https://armanipay.com/",
        },
      ],
    },
  ];

  // Combine all projects for the "All" tab
  const allProjects = portfolioData.flatMap((item) => item.projects);

  // States
  const [activeTab, setActiveTab] = useState("All");
  const [showAll, setShowAll] = useState(false);

  // Filter projects based on active category
  const filteredProjects =
    activeTab === "All"
      ? allProjects
      : portfolioData.find((category) => category.category === activeTab)
          ?.projects || [];

  // Limit displayed projects initially, show more when "Load More" is clicked
  const displayedProjects = showAll
    ? filteredProjects
    : filteredProjects.slice(0, 2);

  // Reference for scrolling
  const tabRef = useRef(null);

  // Variables for Drag Scrolling
  let isDragging = false;
  let startX, scrollLeft;

  // Function to Start Dragging
  const startDragging = (e) => {
    isDragging = true;
    tabRef.current.classList.add("cursor-grabbing");
    startX = e.pageX - tabRef.current.offsetLeft;
    scrollLeft = tabRef.current.scrollLeft;
  };

  // Function to Handle Dragging
  const whileDragging = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - tabRef.current.offsetLeft;
    const walk = (x - startX) * 2; // Faster movement
    tabRef.current.scrollLeft = scrollLeft - walk;
  };

  // Function to Stop Dragging
  const stopDragging = () => {
    isDragging = false;
    tabRef.current.classList.remove("cursor-grabbing");
  };

  return (
    <div className="section p-6" id="section-portfolio">
      <div className="content flex justify-between items-start mb-6">
        <div className="titles">
          <div className="title text-2xl font-bold">Portfolio</div>
        </div>
      </div>

      {/* Scrollable Tabs */}
      <div
        ref={tabRef}
        className="flex gap-2 mb-6 overflow-x-auto whitespace-nowrap no-scrollbar cursor-grab select-none border-[#e3e3e33c]"
        onMouseDown={startDragging}
        onMouseMove={whileDragging}
        onMouseUp={stopDragging}
        onMouseLeave={stopDragging}
      >
        <span
          className={`hover:border-[#f0edcc] px-4 py-2 border border-[#e3e3e33c] font-bold cursor-pointer text-sm rounded-full transition-all ${
            activeTab === "All"
              ? "bg-[#f0edcc] text-[#02343f]"
              : "bg-white text-[#fff]"
          }`}
          onClick={() => {
            setActiveTab("All");
            setShowAll(false);
          }}
        >
          All
        </span>
        {portfolioData.map((category, index) => (
          <span
            key={index}
            className={`hover:border-[#f0edcc] px-4 py-2 border font-bold cursor-pointer text-sm rounded-full transition-all border-[#e3e3e33c] ${
              activeTab === category.category
                ? "bg-[#f0edcc] text-[#02343f]"
                : "bg-white text-[#fff]"
            }`}
            onClick={() => {
              setActiveTab(category.category);
              setShowAll(false);
            }}
          >
            {category.category}
          </span>
        ))}
      </div>

      {/* Dynamic Portfolio Content */}
      <div className="portfolio-content grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 gap-6 ">
        {displayedProjects.map((project, index) => (
          <div
            key={index}
            className="portfolio-item bg-white shadow-md rounded-lg overflow-hidden transition-transform hover:scale-105"
          >
            <a href={project.url} target="_blank">
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-auto md:h-44 object-cover"
              />
            </a>
            <div className="px-4 pt-4 text-center">
              <h3 className="text-lg font-bold mb-2 text-[#fff]">
                <a href={project.url} target="_blank">
                  {project.title}
                </a>
              </h3>
              <p className="text-gray-600">{project.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Load More Button */}
      {!showAll && filteredProjects.length > 3 && (
        <div className="flex justify-center mt-6">
          <span
            className="px-4 py-2 border cursor-pointer text-sm rounded-full border-[#e3e3e33c] text-[#fff] hover:border-[#f0edcc]  transition-all"
            onClick={() => setShowAll(true)}
          >
            Load More
          </span>
        </div>
      )}
    </div>
  );
};

export default PortfolioSection;
